import { 
  currentView, 
  selectedAccountId, 
  selectedPropertyId 
} from '../state'
import { 
  showGoogleStatusModal, 
  integrations 
} from '../../use-integration-management/state'

/**
 * Closes the Google status modal and resets state
 */
export const closeGoogleStatusModal = () => {
  showGoogleStatusModal.value = false

  // If closing without property selection, reset Google integration state if not already connected
  if (currentView.value === 'accounts' || !selectedPropertyId.value) {
    const googleIntegration = integrations.value.find((i) => i.id === 6)
    if (googleIntegration && !googleIntegration.connected) {
      googleIntegration.connected = false
    }
  }

  // Reset all state
  currentView.value = 'accounts'
  selectedAccountId.value = null
  selectedPropertyId.value = null
}
